<template>
  <div v-if="release" class="scroll-vertical">
    <content-nav-bar>
      <a
        @click="refresh"
        class="level-item">
        <svgicon name="refresh" height="25" width="25"></svgicon>
      </a>
      <p class="level-item is-size-4">Release Information</p>
    </content-nav-bar>
    <detail-item
      name="Version"
      imgName="circle">
      {{ release.major }}.{{ release.minor }}.{{ release.build }}
    </detail-item>
    <detail-item
      name="UUID"
      imgName="circle">
      {{ release.uuid }}
    </detail-item>
    <detail-item
      name="Vanilla Package"
      imgName="circle">
      s3://{{ release.bucket }}/{{ release.key }}
    </detail-item>
    <b-table
      class="release-organizations-table"
      :data="release.organizations"
      :checkable="false">
      <template slot-scope="props">
        <b-table-column field="released" label="Released" centered>
          <switch-watch :id="props.row.hd" :value="props.row.released" :onChange="onChange">
          </switch-watch>
        </b-table-column>
        <b-table-column field="hd" label="Organization">
          {{ props.row.hd }}
        </b-table-column>
        <b-table-column field="status" label="Build Status">
          <span class="tag">
            {{ props.row.status.toUpperCase() }}
          </span>
        </b-table-column>
        <b-table-column field="package" label="Package">
          s3://{{ props.row.bucket }}/{{ props.row.key }}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>s

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import DetailItem from '@/components/DetailItem.vue';
import SwitchWatch from '@/components/SwitchWatch.vue';

export default {
  name: 'ReleaseDetails',
  components: { ContentNavBar, DetailItem, SwitchWatch },
  props: {
    release: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async refresh() {
      await this.$store.dispatch('admin/getRelease', {
        uuid: this.$route.params.id,
      });
    },
    async onChange(hd, released) {
      await this.$store.dispatch('admin/updateReleaseOrganizationStatus', {
        uuid: this.release.uuid,
        hd,
        released,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
